import { AuthService } from './../../../services/auth.service';
import { GetObjectPipe } from '../../../core/pipes/get-object.pipe';
import { Component, OnInit, HostBinding, ChangeDetectionStrategy } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { LayoutConfigService } from '../../../core/services/layout-config.service';
import * as objectPath from 'object-path';
import { TokenService } from '../../../services/token.service';

@Component({
	selector: 'm-footer',
	templateUrl: './footer.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class FooterComponent implements OnInit {
	@HostBinding('class') classes = 'm-grid__item m-footer';

	footerContainerClass$: BehaviorSubject<string> = new BehaviorSubject('');

	date = (new Date()).getFullYear();

	constructor(
		private configService: LayoutConfigService,
		private authService: AuthService,
		private tokenService: TokenService,
		) {
		this.configService.onLayoutConfigUpdated$.subscribe(model => {
			const config = model.config;

			let pageBodyClass = '';
			const selfLayout = objectPath.get(config, 'self.layout');
			if (selfLayout === 'boxed' || selfLayout === 'wide') {
				pageBodyClass += 'm-container--responsive m-container--xxl';
			} else {
				pageBodyClass += 'm-container--fluid';
			}
			this.footerContainerClass$.next(pageBodyClass);
		});
	}

	ngOnInit(): void {}

	public get trialMode(): boolean {
		return this.authService.trial;
	}

	public get trial$(): Observable<boolean> {
		return this.tokenService.trial$;
	}

	public getTermsAndConditionsLink(): string {
		if (window.location.pathname.includes('showroom')) {
			return '/showroom/terms-and-conditions';
		}
		return '/vendor/terms-and-conditions';
	}

	public getPrivacyPolicyLink(): string {
		if (window.location.pathname.includes('showroom')) {
			return '/showroom/privacy-policy';
		}
		return '/vendor/privacy-policy';
	}

	public isShowroomUser(): boolean {
		const roles = this.tokenService.getRoles();
		return roles.includes('showroom_admin') || roles.includes('sales');
	}

	public isVendorUser(): boolean {
		const roles = this.tokenService.getRoles();
		return roles.includes('vendor_user') || roles.includes('vendor_admin');
	}

	public getModulePrefix(): string {
		return this.isShowroomUser() ? 'showroom' : 'vendor';
	}
}
